module.exports = __webpack_public_path__ + "static/img/newsDetailPic5.19e14ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic5.png
// module id = FNoW
// module chunks = 1